import { memo } from 'react';

import { SharePermissionSection } from '~/components/SharePrivateContentModal/SharePrivateContentSettings/SharePermissionSection';
import { type SharePermissionSectionContentProps } from '~/components/SharePrivateContentModal/SharePrivateContentSettings/types';
import { SharePrivateContentPermissionToggle } from '~/components/SharePrivateContentModal/shared/SharePrivateContentPermissionToggle';

type ShareVersionsPermissionsProps = {
  canViewAllVersions: boolean;
} & SharePermissionSectionContentProps;

export const ShareVersionsPermissions = memo(
  ({ onPermissionUpdated, shortIdInfo, isLoading, canViewAllVersions }: ShareVersionsPermissionsProps) => {
    return (
      <SharePermissionSection title="Versions">
        <SharePrivateContentPermissionToggle
          label="Show versions"
          id="canViewAllVersions"
          isLoading={isLoading}
          checked={shortIdInfo.permissions.asset.canViewAllVersions}
          onCheckedChange={(checked) => onPermissionUpdated({ asset: { canViewAllVersions: checked } })}
          disabled={!canViewAllVersions}
        />
      </SharePermissionSection>
    );
  },
);

ShareVersionsPermissions.displayName = 'ShareViewerPermissions';
